import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=c531a2f0&scoped=true"
import script from "./Anexos.vue?vue&type=script&lang=js"
export * from "./Anexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c531a2f0",
  null
  
)

export default component.exports